import React from 'react';
import { Form, Input, Select, Typography, Switch, Row, Col } from 'antd';

const { Text } = Typography;
const { Option } = Select;

const MergeNodeProperties = ({ config }) => {
  return (
    <>
      <Form.Item label="Merge Strategy" name="mergeStrategy" initialValue={config.mergeStrategy || 'union'} rules={[{ required: true }]}>
        <Select>
          <Option value="union">Union (combine all rows)</Option>
          <Option value="intersect">Intersect (common rows only)</Option>
          <Option value="except">Except (left minus right)</Option>
          <Option value="concat">Concat (append right to left)</Option>
        </Select>
      </Form.Item>

      <Row gutter={12}>
        <Col span={12}>
          <Form.Item label="Remove Duplicates" name="removeDuplicates" initialValue={config.removeDuplicates !== false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Sort Result" name="sortResult" initialValue={config.sortResult || false} valuePropName="checked">
            <Switch />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item label="Column Alignment" name="columnAlignment" initialValue={config.columnAlignment || 'byName'}>
        <Select>
          <Option value="byName">By Column Name</Option>
          <Option value="byPosition">By Position</Option>
          <Option value="strict">Strict (must match exactly)</Option>
        </Select>
      </Form.Item>

      <Form.Item label="Handle Missing Columns" name="handleMissing" initialValue={config.handleMissing || 'null'}>
        <Select>
          <Option value="null">Fill with null</Option>
          <Option value="skip">Skip rows</Option>
          <Option value="error">Raise error</Option>
          <Option value="default">Use default value</Option>
        </Select>
      </Form.Item>

      {config.handleMissing === 'default' && (
        <Form.Item label="Default Value" name="defaultValue" initialValue={config.defaultValue || ''}>
          <Input placeholder="Default value for missing columns" />
        </Form.Item>
      )}

      <div style={{ padding: '8px 12px', backgroundColor: '#f9f9f9', borderRadius: '4px', fontSize: '12px', marginTop: '12px' }}>
        <Text type="secondary">
          <strong>Merge Node:</strong><br/>
          • <strong>Union:</strong> Combines all rows from both datasets<br/>
          • <strong>Intersect:</strong> Only rows present in both datasets<br/>
          • <strong>Except:</strong> Rows in left but not in right<br/>
          • <strong>Concat:</strong> Simply appends right dataset to left<br/>
          • Requires two input connections (datasets to merge)
        </Text>
      </div>
    </>
  );
};

export default MergeNodeProperties;